// src/i18n.ts

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
import enProjects from './locales/en/projects.json';
import frProjects from './locales/fr/projects.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
        projects: enProjects,
      },
      fr: {
        translation: frTranslation,
        projects: frProjects,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    ns: ['translation', 'projects'], // Register namespaces
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
  });

export default i18n;